import { gql } from "@apollo/client";
import { PRODUCT_PER_PAGE } from "@/utils/constants/product";
import { PAGE_INFO } from "./global";
import { getTaxonomyEnumBySlug, getTaxonomyFuncBySlug } from "../constants/taxonomy";
import { PRODUCT_FRAGMENTS } from "./product";
export const TAXONOMY_FIELDS = `
id
name
description
seo {
	fullHead
}
`;

export const TAXONOMY_PRODUCT_FIELDS = `
nodes {
	${PRODUCT_FRAGMENTS}
}
`

export const POPULAR_PRODUCT_FIEDLS = `
nodes {
	${PRODUCT_FRAGMENTS}
}
`
export const POPULAR_GQL = gql`
query POPULAR_PRODUCTS($taxonomy: ProductTaxonomyEnum!, $terms: String!) {
	products(
		where: {taxonomyFilter: {filters: {taxonomy: $taxonomy, terms: [$terms]}, relation: AND}, featured: true}
    	first: 2
	) {
		${POPULAR_PRODUCT_FIEDLS}
	}
}`;

export const SHOP_PRODUCTS = gql`
query SHOP_PRODUCTS($after:String){
	products(
		where: { featured: true, orderby: {field: TOTAL_SALES, order: DESC}}
    	first: ${PRODUCT_PER_PAGE}
		after: $after
	) {
		${POPULAR_PRODUCT_FIEDLS}
		pageInfo {
			hasNextPage
			endCursor
		}
	}
}`;

export const ON_SALE_PRODUCTS = gql`
query SHOP_PRODUCTS($after:String){
	products(
		where: {orderby: {field: TOTAL_SALES, order: DESC}, onSale: true}
    	first: 100
		after: $after
	) {
		${POPULAR_PRODUCT_FIEDLS}
		pageInfo {
			hasNextPage
			endCursor
		}
	}
}`;

export const POPULAR_CUSTOM_GQL = gql`
query POPULAR_PRODUCTS($taxonomy: ProductTaxonomyEnum!, $terms: String!) {
	products(
		where: {taxonomyFilter: {filters: {taxonomy: $taxonomy, terms: [$terms], operator: IN}, relation: AND}, orderby: {field: REGULAR_PRICE, order: ASC}, featured: true}
		first: 2
	) {
		${POPULAR_PRODUCT_FIEDLS}
	}
}`;

export const TAXONOMY_BANNER_DATA_GQL = gql
	`query TAXONOMY_BANNER_DATA_GQL($taxonomy: String!, $term: String!) {
		categoryBanner(term_slug: $term, tax_slug: $taxonomy) {
			sourceUrl:image
			name
			description
		}
	}`;

export const TAXONOMY_FILTER_OPTIONS_GQL = gql`
query TAXONOMY_FILTER_OPTIONS_GQL($taxonomy: String!, $term: String!, $onSale: String) {
	typeFilterOptions: taxonomyFilterOptions(
		currentPagetaxonomySlug: $taxonomy
		termSlug: $term
		taxonomySlugForGetTerms: "product-type"
		onSale: $onSale
	) {
		label
		count: term_count
		value
	}
	occassionFilterOptions: taxonomyFilterOptions(
		currentPagetaxonomySlug: $taxonomy
		termSlug: $term
		taxonomySlugForGetTerms: "occasion"
		onSale: $onSale
	) {
		label
		count: term_count
		value
	}
	suitableFilterOptions: taxonomyFilterOptions(
		currentPagetaxonomySlug: $taxonomy
		termSlug: $term
		taxonomySlugForGetTerms: "shop-by"
		onSale: $onSale
	) {
		label
		count: term_count
		value
	}
	favouriteFilterOptions: taxonomyFilterOptions(
		currentPagetaxonomySlug: $taxonomy
		termSlug: $term
		taxonomySlugForGetTerms: "favourite"
		onSale: $onSale
	) {
		label
		count: term_count
		value
	}
	priceFilterOptions: categoryPriceFilter(
		tax_slug: $taxonomy
		term_slug: $term
	) {
		label
		count:product_count
		value
		currency
	}
	sortOptions: categorySortOption {
		label
		value
	}
}`;


export const getProductTaxonomyEnum = (slug) => {
	if (slug == 'product-category') {
		return 'PRODUCTCATEGORY'
	} else if (slug == 'product-tag') {
		return 'PRODUCTTAG'
	} else if (slug == 'gift_box_size') {
		return 'GIFTBOXSIZE'
	} else if (slug == 'product-type') {
		return 'PRODUCTTAXONOMYTYPE'
	} else if (slug == 'favourite') {
		return 'PRODUCTTAXONOMYFAVOURITE'
	} else if (slug == 'occasion') {
		return 'PRODUCTTAXONOMYOCCASION'
	} else if (slug == 'shop-by') {
		return 'PRODUCTTAXONOMYSHOPBY'
	} else {
		return null;
	}
}
